<template>
    <div class="announ">
        <div class="title">项目分布图</div>
        <div class="block" id="chinaMap"></div>
    </div>
</template>

<script>
import '@/utils/china'
import {url,operate} from '@/utils/config'
import {postFun,getFun,deleteFun} from '@/utils/httpFun'
export default {
    components: {

    },
    data: () => ({
        mapData:[],
        myChart: {},
    }),
    computed: {
        refreshStr() {
            return this.$store.state.windowwidth || this.$store.state.windowwidth;
        }
    },
    watch: {
        refreshStr(val) {
            if (val) {
                this.myChart.resize()
            }
        }
    },
    mounted() {
        this.getInfo()
    },
    methods: {
        getInfo() {
            getFun(operate.PROJECTMAP,{},res=>{
                let list = res.data
                let maxVal = 0;
                let listArray = []
                    for(var i in list){
                        var projectCount=list[i].projectCount;
                        maxVal= projectCount>maxVal?projectCount:maxVal;
                        if(!!list[i].addressName){
                            listArray.push({name:list[i].addressName,value:projectCount}) 
                        }
                    }
                this.maxVal = maxVal+2
                this.mapData = listArray
                this.init()
            }) 
        },
        init() {
            let myChart = this.$_echarts.init(document.getElementById('chinaMap'))
            this.myChart = myChart
            let option = {
                title: {
                    itemGap: 30,
                    left: 'center',
                    textStyle: {
                        color: '#000',
                        fontStyle:'normal',
                        fontWeight:'bold',
                        fontSize: 30
                    },
                    subtextStyle: {
                        color: '#58d9df',
                        fontStyle: 'normal',
                        fontWeight: 'bold',
                        fontSize: 16
                    }
                },

                tooltip: {
                    trigger: 'item',
                    formatter: function (e) {
                        var name = e.name ? e.name : '获取中';
                        var value = e.value ? e.value : '暂无数据'
                        return `${name}<br/>项目数量:${value} `
                    }
                },

                visualMap: {
                    min: 0,
                    max:this.maxVal,
                    left: 'left',
                    top: 'bottom',
                    text: ['高', '低'],
                    calculable: true,
                    inRange: {
                        color: ['#EBEFFA', '#BFECFF', '#3A9EFF', '#2468D9']
                    }
                },
                toolbox: {
                    show: false,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center',
                    feature: {
                        dataView: {
                            readOnly: false
                        },
                        restore: {},
                        saveAsImage: {}
                    }
                },

                geo: {
                    map: 'china',
                    zoom: 1.28,
                    nameMap:{
                        'China' : '中国'
                    },
                    label: {
                        normal: {
                            show: true,
                            color: '#5F6472',
                            fontSize:12
                        },
                        emphasis: {
                            show: false,
                            color: '#292929'
                        }
                    },
                    roam: false,
                    itemStyle: {
                        normal: {
                            borderWidth:0.03,
                            areaColor: '#fbfbfb',
                            borderColor: '#000000'

                        },
                        emphasis: {
                            borderWidth:0.03,
                            borderColor: '#000000',
                            areaColor:"#2D7CFF",
                        }
                    }
                },
                series: [{
                    type: 'map',
                    mapType: 'china',
                    geoIndex: 0,
                    label: {
                        normal: {
                            show: true
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    data: this.mapData
                }]
            };
            this.myChart.setOption(option);
        }
    },
}
</script>
<style lang="scss" scoped>
.announ {
    background: #FFFFFF;
    border-radius: 10px;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
}

.title {
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: #323F51;
    letter-spacing: 0;
    line-height: 18px;
    font-weight: 600;
    margin-bottom: 20px;
}

.block {
    height:450px;
}
</style>
